class PasswordDrop extends Theme.Component {
  static STORAGE_KEY = 'password-drop:authenticated';

  connectedCallback() {
    super.connectedCallback();

    this.defineElements({
      form: '[data-password-form]',
      input: '[data-password-input]',
      error: '[data-password-error]',
      unlock: '[data-unlock]'
    });

    this.elements.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submitPassword();
    });

    this.classList.add('password-drop--ready');
  }

  showForm() {
    this.elements.unlock.style.display = 'none';
    this.elements.form.classList.add('unlocked');
    this.elements.input.focus();
  }

  submitPassword() {
    const value = this.elements.input.value.trim();

    if (value === this.dataset.password) {
      sessionStorage.setItem(PasswordDrop.STORAGE_KEY, '1');
      this.classList.add('password-drop--exiting');
      this.addEventListener('transitionend', () => this.remove(), { once: true });
      setTimeout(() => this.remove(), 600);
    } else {
      this.elements.error.textContent = 'Incorrect password';
      this.elements.error.style.display = '';
      this.elements.input.value = '';
      this.elements.input.focus();
    }
  }
}

customElements.define('password-drop', PasswordDrop);
